import React from 'react';
import Table from '../../../../component/table/Table';
import Pagination from '../../../../component/pagination';
import DataNotFound from '../../../components/dataNotFound';

function VedorTable({
	loader,
	tableData,
	vendorColoum,
	onRowClick,
	setBulkAction,
	bulkAction,
	handleDeselectAll,
	page,
	totalPages,
	handlePageChange,
	isAdvanceFilterApplied,
	setParams,
	pageSize,
	disabled,
	onClick,
}) {

	if (loader) {
		return (
			<div
				className="d-flex justify-content-center align-items-center"
				style={{ height: '100%', marginTop: '20%' }}
			>
				<span
					className="Page_loader"
					role="status"
					aria-hidden="true"
				></span>
			</div>
		);
	}
	return (
		<div>
			{tableData.length > 0 ? (
				<div className="productTable-body">
					<Table
						row={tableData}
						coloum={vendorColoum}
						className="productTable"
						onRowClick={onRowClick}
						action={setBulkAction}
						bulkAction={bulkAction}
						style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : { height: 'calc(100vh - 148px)' }}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			) : (
				<DataNotFound
					title={'Grow smarter with trusted vendors!'}
					subtitle={'Keep all your vendors in one place.'}
					descriptionTitle={'Stay in control!'}
					descriptionSubTitle={'Add your vendor list to streamline purchases, bills,'}
					descriptionContent={'and transactions — all in one place.'}
					buttonText={'Create New Vendor'}
					disabled={disabled}
					onClick={() => onClick()}
				/>
			)}

			{tableData.length > 0 && (
				<Pagination
					currentPage={page}
					totalPages={totalPages}
					onChangePage={handlePageChange}
					pageSize={pageSize}
					setParam={setParams}
				/>
			)}
		</div>
	);
}

export default VedorTable;
